module.exports = __webpack_public_path__ + "public/images/event-calendar.c5183a91f9e2179b6e2f0ce507251c43.svg";